import animation from '@helpers/animation';
import styled, { css } from 'styled-components';

const Image = styled.img<{ aspectRatio: string; blur: boolean }>`
  object-fit: cover;
  object-position: center center;

  transition: filter 500ms ${animation.easeInOutCubic};

  ${({ aspectRatio }) => css`
    aspect-ratio: ${aspectRatio};
  `}

  ${({ blur }) =>
    blur
      ? css`
          filter: blur(20px);
        `
      : css`
          filter: blur(0px);
        `}
`;

export const LazyImageStyles = {
  Image,
};
